import type { Organisation } from "@/types";

export interface User {
  id: number;
  username: string;
  email: string;
  phone_number?: string;
  password?: string;
  first_name: string;
  last_name: string;
  job_title?: string;
  profile_picture?: string;
  gender?: Gender;
  organisation_id: number | null;
  organisation?: Organisation;
  role: UserRole;
}

export const UserRoles = {
  SuperAdmin: "super_admin",
  Admin: "admin",
  ManagerExtended: "manager_extended",
  Manager: "manager",
  Viewer: "viewer",
  ViewerExtended: "viewer_extended",
  Respondent: "respondent",
} as const;

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];

export const Genders = {
  Male: "male",
  Female: "female",
  Other: "other",
} as const;

export type Gender = (typeof Genders)[keyof typeof Genders];

export interface Credentials {
  username?: string;
  email?: string;
  password?: string;
}
